import { AccountInfo, IPublicClientApplication } from '@azure/msal-browser';

import {
  FETCH_USER,
  FETCH_USERS,
  INITIAL_FETCH_USER,
  SET_ACCESS_TOKEN,
  SET_MSAL_ACCOUNT,
  SET_MSAL_INSTANCE,
} from './types';

export function initialFetchUser(
  accessToken: null | string,
  msalInstance: null | IPublicClientApplication,
  msalAccount: null | AccountInfo
): any {
  return {
    type: INITIAL_FETCH_USER.PENDING,
    accessToken,
    msalInstance,
    msalAccount,
  };
}

export function fetchUser(withoutTokenRefresh?: boolean): any {
  return {
    type: FETCH_USER.PENDING,
    withoutTokenRefresh,
  };
}

export function fetchUsers() {
  return {
    type: FETCH_USERS.PENDING,
  };
}

export function setAccessToken(accessToken: null | string): {
  type: string;
  accessToken: null | string;
} {
  return {
    type: SET_ACCESS_TOKEN,
    accessToken,
  };
}

export function setMsalInstance(
  msalInstance: null | IPublicClientApplication
): {
  type: string;
  msalInstance: null | IPublicClientApplication;
} {
  return {
    type: SET_MSAL_INSTANCE,
    msalInstance,
  };
}

export function setMsalAccount(msalAccount: null | AccountInfo): {
  type: string;
  msalAccount: null | AccountInfo;
} {
  return {
    type: SET_MSAL_ACCOUNT,
    msalAccount,
  };
}
